import React, { useState } from "react";
import ProgressBar from "../Common/ProgressBar";
import SelectBox from "../../../UI/SelectBox";
import { ClosedYears,VeryLenderArray } from "../../../../Constants/Constants";
import InputButton from "../../../UI/InputButton";
import RadioButton from "../../../UI/RadioButton";
import Modal from "react-bootstrap/Modal";

const WhatYearHappen = ({
  className,
  slideChange,
  textHeadingLine1,
  validationMsg,
  clearErrors,
  validation,
  backClick,
  trigger,
  getValues,
}) => {

  const [agreeModalShow, setAgreeModalShow] = useState("hide");
  const [claimModal, setshowClaimModal] = useState(false);
  const handleCloseclaimModal = () => setshowClaimModal(false);
  

  const nextSlide = async (e) => {
    let errorFlag = 0;
    let yearresult = await trigger("whatYearThisHappen");

    if (!yearresult) {
      errorFlag = 1;
      return false;
    }
    const formData = getValues();
    let yearSelected = formData.whatYearThisHappen;
    if (yearSelected < 2019) {
      setshowClaimModal(true);
    } else {
      slideChange(e);
    }

  };

  return (
    <>
      <div id="slide-2" className={`${className}`}>
        <ProgressBar value="23" />

        <h3> { textHeadingLine1 } </h3>
        <div className="input-section mb-3">
        
          <SelectBox
            className="form-select form-control"
            OptionValue={ClosedYears}
            name="whatYearThisHappen"
            id="whatYearThisHappen"
            onChange={() => clearErrors("whatYearThisHappen")}
            clearErrors={clearErrors}
            myRef={validation({ required: "Please Select Year" })}
            validationMsg={
              validationMsg.whatYearThisHappen && validationMsg.whatYearThisHappen.message
            }
          ></SelectBox>
       
        </div>

        <InputButton
          name="WhatYearThisHappen"
          className="btn next08  regNextBtn"
          id=""
          value="Next"
          btnType="button"
          onClick={nextSlide}
          style={{ float: "none" }}
        />

        <div>
          <p className="text-center">
            <span
              className="back1 back-btn btn-link"
              name="back03da"
              children="<< Previous"
              onClick={backClick}
            ></span>
          </p>
        </div>

        <Modal size="md" show={claimModal} onHide={handleCloseclaimModal} centered backdrop="static" className="modaloutersec">
        <Modal.Body>
         <h5 className="text-center mb-3">Sorry, we cannot accept your claim</h5>
          <div className="input-group prevname-Btnpop justify-content-center">
            <InputButton
              className="btn next08 regNextBtnNew regNxtBtnNw text-center"
              name="modalBack"
              value="Back"
              btnType="button"
              onClick={handleCloseclaimModal}
            />
          </div>
        </Modal.Body>
      </Modal>
      </div>
    </>
  );
};
export default WhatYearHappen;
